import React from 'react';

const Logo = ({ className = "h-8 w-auto", showText = true, variant = "light" }) => {
  // Infobip-inspired logo with geometric elements
  const isLight = variant === "light";
  
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Geometric Logo Mark - Engineering inspired */}
      <div className="relative flex items-center justify-center">
        {/* Main circle with orange gradient */}
        <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-primary-500 to-primary-600 flex items-center justify-center shadow-orange">
          {/* Inner geometric shape - bracket inspired */}
          <svg 
            viewBox="0 0 24 24" 
            className="w-5 h-5 text-white"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            {/* Chat bubble with connection nodes */}
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
            {/* Connection dot */}
            <circle cx="12" cy="12" r="1.5" fill="currentColor" />
          </svg>
        </div>
        {/* Decorative connection line */}
        <div className="absolute -right-1 top-1/2 w-2 h-0.5 bg-primary-400 rounded-full transform -translate-y-1/2" />
      </div>

      {/* Brand Text */}
      {showText && (
        <div className="flex flex-col">
          <span className={`text-lg font-bold tracking-tight leading-none ${
            isLight ? 'text-white' : 'text-neutral-800'
          }`}>
            Chatza
          </span>
          <span className={`text-[10px] font-medium tracking-wider uppercase ${
            isLight ? 'text-white/70' : 'text-neutral-500'
          }`}>
            Client Manager
          </span>
        </div>
      )}
    </div>
  );
};

// Compact logo for tight spaces
export const LogoCompact = ({ className = "w-9 h-9" }) => {
  return (
    <div className={`rounded-lg bg-gradient-to-br from-primary-500 to-primary-600 flex items-center justify-center shadow-orange ${className}`}>
      <svg 
        viewBox="0 0 24 24" 
        className="w-5 h-5 text-white"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
        <circle cx="12" cy="12" r="1.5" fill="currentColor" />
      </svg>
    </div>
  );
};

export default Logo;
